module.exports = "/_next/static/images/c9c60ff909c68bb4b5290d0cec81bddb-google-pay.png";